import { useState, useRef, useEffect } from "react";
import { FaRegQuestionCircle } from "react-icons/fa";
import "./style.scss";

const Tooltip = ({
  children,
  tooltipText,
  iconAdjustemntMaring = {},
  isToolTipFullWidth,
}) => {
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);

  const tooltipRef = useRef(null);
  const hideTimeout = useRef(null);

  useEffect(() => {
    if (isTooltipVisible && tooltipRef.current) {
      const tooltipElement = tooltipRef.current;

      // Reset styles to avoid any residual positioning from previous renders
      tooltipElement.style.left = "50%";
      tooltipElement.style.right = "auto";
      tooltipElement.style.transform = "translateX(-50%)";

      // Adjust positioning if it overflows the viewport
      const { left, width } = tooltipElement.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      if (left + width > viewportWidth) {
        // Shift left if tooltip overflows right boundary
        tooltipElement.style.left = "auto";
        tooltipElement.style.right = "0";
        tooltipElement.style.transform = "none";
      }
    }
  }, [isTooltipVisible]);

  const handleMouseEnter = () => {
    clearTimeout(hideTimeout.current);
    setIsTooltipVisible(true);
  };

  const handleMouseLeave = () => {
    hideTimeout.current = setTimeout(() => setIsTooltipVisible(false), 250);
  };

  return (
    <div
      className="tooltip-container"
      style={{ width: isToolTipFullWidth ? "100%" : "40%" }}
    >
      {children}

      {tooltipText ? (
        <div
          className="tooltip-icon-container"
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <FaRegQuestionCircle
            className="tooltip-icon"
            style={iconAdjustemntMaring}
          />

          <div
            className={`tooltip-wrapper ${
              isTooltipVisible ? "visible-tooltip" : ""
            }`}
            ref={tooltipRef}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
          >
            <span className="tooltip">{tooltipText}</span>
          </div>
        </div>
      ) : (
        <div className="tooltip-icon-container" aria-hidden>
          <FaRegQuestionCircle
            className="tooltip-icon"
            style={{ ...iconAdjustemntMaring, visibility: "hidden" }}
          />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
